import { render, staticRenderFns } from "./ThanksStepComponentB.vue?vue&type=template&id=22c3ad17"
import script from "./ThanksStepComponentB.vue?vue&type=script&lang=ts"
export * from "./ThanksStepComponentB.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports